class StringUtils {
    static EMPTY = '';
    static SPACE = ' ';

    static isEmpty(value) {
        return value == null || value.length === 0;
    }

    static isNotEmpty(value) {
        return !StringUtils.isEmpty(value);
    }

    static isBlank(value) {
        if (value == null) {
            return true;
        }

        if (typeof value !== 'string') {
            return false;
        }

        let trimmedValue = value.trim();
        return trimmedValue.length === 0;
    }

    static isNotBlank(value) {
        return !StringUtils.isBlank(value);
    }

    static toCapitalizedWords(value) {
        var words = value.match(/[A-Za-z][a-z]*/g) || [];
    
        return words.map(StringUtils.capitalize).join(" ");
    }
    
    static capitalize(value) {
        return value.charAt(0).toUpperCase() + value.substring(1);
    }

    static snakeCaseToCamelCase(word) {
        return word.replace(/(-\w)/g, matches => matches[1].toUpperCase());
    }

    static _sanitizeName(name) {
        return name.replace(/[\\/]/gi, '-');
    }

    static cutName(name){
        let result = name.substring(0, name.indexOf('-'));
        if(result.length === 0){
            let resultArray = name.split(" ");
            return resultArray[0] + " " + resultArray[1] + " " + resultArray[2] + " " + resultArray[3];
        } else {
            return result;
        }
    }
}

export default StringUtils;